import { render, staticRenderFns } from "./popup-sync.vue?vue&type=template&id=54619d01&scoped=true"
import script from "./popup-sync.vue?vue&type=script&lang=js"
export * from "./popup-sync.vue?vue&type=script&lang=js"
import style0 from "./popup-sync.vue?vue&type=style&index=0&id=54619d01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54619d01",
  null
  
)

export default component.exports